import * as React from 'react';
import { ProductSizeInterface } from '../../../../Interface/ProductSize';
import { Col, Row } from 'react-bootstrap';
import ProductImage from './ProductImage/ProductImage';
import ProductSizeInformation from '../Abstracts/ProductSizeInformation/ProductSizeInformation';
import InfoButton from '../Abstracts/InfoButton/InfoButton';
import FavoriteButton from '../Abstracts/FavoriteButton/FavoriteButton';
import ProductSizePrice from '../Abstracts/ProductSizePrice/ProductSizePrice';
import useViewports from '../../../Hooks/useViewports';

export default function ProductSizeImage({
  product_size,
  onImageClick,
}: {
  product_size: ProductSizeInterface;
  onImageClick?: () => void;
}) {
  const { lg, xl, xxl } = useViewports();
  const isDesktop = lg || xl || xxl;

  return (
    <Col className="order-md-2 order-lg-1" xs={12} lg={4} xxl={3}>
      {isDesktop ? (
        <div className="d-none d-lg-block">
          <ProductImage
            product_size={product_size}
            onImageClick={onImageClick}
          />
        </div>
      ) : (
        /* mobile content */
        <Row className="d-flex d-lg-none">
          <Col xs={6} md={5}>
            <ProductImage
              product_size={product_size}
              onImageClick={onImageClick}
            />
          </Col>
          <Col>
            <Row className="my-3">
              <Col>
                <ProductSizeInformation product_size={product_size} />
              </Col>
            </Row>
            <Row className="my-3">
              <Col className="d-flex ps-0 ps-lg-2">
                <div className="mx-2">
                  <InfoButton product_size={product_size} />
                </div>
                <div className="mx-2">
                  <FavoriteButton
                    erp_id={product_size.erp_id}
                    is_favorite={product_size.is_favourite}
                  />
                </div>
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <ProductSizePrice product_size={product_size} />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Col>
  );
}
